import "~/src/stylesheets/ui/projects-carousel.css";

const ProjectsCarousel = () => {
  // Activar scroll horizontal con drag y prevenir clics si hubo movimiento
  requestAnimationFrame(() => {
    const wrapper = document.querySelector(".carousel__wrapper");
    if (!wrapper) return;

    let isDragging = false;
    let startX;
    let scrollLeft;
    let moved = false;

    const links = wrapper.querySelectorAll("a");

    wrapper.addEventListener("mousedown", (e) => {
      isDragging = true;
      moved = false;
      wrapper.classList.add("dragging");
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > 5) moved = true;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    wrapper.addEventListener("mouseup", () => {
      isDragging = false;
      wrapper.classList.remove("dragging");
    });

    wrapper.addEventListener("mouseleave", () => {
      isDragging = false;
      wrapper.classList.remove("dragging");
    });

    // Prevenir el click si hubo arrastre
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        if (moved) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    });
  });

  return /*html*/ `
    <section class="projects__carousel">
      <div class="carousel__header">
        <h6 id="projects">Encontrá tu proyecto ideal</h6>
      </div>
      <div class="carousel__container">
        <div class="carousel__wrapper">
          <div class="carousel">
            <a href="/voir/suites" draggable="false">
              <figure>
                <img src="/pics/suites/Edificio Dia.webp" width="480" height="720" alt="Suites" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false" draggable="false"/>
                    <p>Suites</p>
                  </span>
                  <span><b>Entrega 2027</b></span>
                </figcaption>
              </figure>
            </a>

            <a href="/voir/cespedes" draggable="false">
              <figure>
                <img src="/pics/voir_cespedes.webp" width="480" height="720" alt="Céspedes" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/pics/LOGO LIVE.webp" width="45" alt="live" draggable="false"/>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false"/>
                    <p>Céspedes</p>
                  </span>
                  <span><b>Entrega 2028</b></span>
                </figcaption>
              </figure>
            </a>

            <a href="/voir/amenabar" draggable="false">
              <figure>
                <img src="/pics/voir_amenabar.webp" width="480" height="720" alt="Amenábar" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false"/>
                    <p>Amenábar</p>
                  </span>
                  <span><b>Entrega inmediata</b></span>
                </figcaption>
              </figure>
            </a>

            <a href="/voir/palpa" draggable="false">
              <figure>
                <img src="/pics/voir_palpa.webp" width="480" height="720" alt="Palpa" draggable="false"/>
                <figcaption>
                  <span>
                    <img src="/vector/VOIR.logo.svg" alt="VOIR" draggable="false"/>
                    <p>Palpa</p>
                  </span>
                  <span><b>Vendido</b></span>
                </figcaption>
              </figure>
            </a>

          </div>
        </div>
      </div>
    </section>
  `;
};

export default ProjectsCarousel;
